import { extractFontById, getTextWidth } from '../../helpers/DocumentUtilsHelper';
import styles from './TextOverflow.module.css'
import { CSSProperties, useEffect, useRef, useState } from "react";

type TextOverflowProps = {
    element: HTMLElement;
    scrollingWidth: number;
    show: boolean;
    text: string;
    onClick?: (position: number) => void;
    style?: CSSProperties
}

function ScrollingOverflow({ element, scrollingWidth, show, text, onClick, style }: TextOverflowProps) {
    const [parts, setParts] = useState<string[]>([])
    const [textLegth, setTextLength] = useState(0)

    const fontFamilyRef = useRef<string | null>(null)
    const fontSizeRef = useRef<string | null>(null)
    const partialSum = useRef<number[]>([])
    const textRef = useRef('')

    const textLengthVariable = '--text-length' as keyof CSSProperties;

    function getScrollWidth(fontData: string) {
        const textWidth = getTextWidth(text, fontData, 0);

        return textWidth - scrollingWidth;
    }

    function getTextLengthPartialSum(words: string[]) {
        const newPartialSum = [words[0].length];
        words.forEach((word, index) => {
            if (index > 0)
                newPartialSum.push(newPartialSum[index - 1] + word.length + 1)
        })

        return newPartialSum;
    }

    useEffect(() => {
        if (show) {
            textRef.current = text;
            const font = extractFontById(element)

            fontFamilyRef.current = font.fontFamily;
            fontSizeRef.current = font.fontSize;

            const words = text.split(' ');
            if (words.length > 0) {
                const newPartialSum = getTextLengthPartialSum(words);
                partialSum.current = newPartialSum;
                
                setTextLength(getScrollWidth(font.fontSize + " " + font.fontFamily))
                setParts(words)
            }
        }
    }, [element, text, show])

    return (
        <>
            {(show && parts.length > 0) &&
            <div 
                className={styles.scrolloverflowtext}
                style={{ 
                    fontFamily: fontFamilyRef.current || '',
                    fontSize: fontSizeRef.current || '',
                    [textLengthVariable]: '-' + textLegth + 'px',
                    animation: textLegth <= 0 ? 'none' : '',
                    ...style
                }}  
            >
                {parts.map((part, index) =>
                    <span 
                        key={part + '' + index} 
                        onClick={() => onClick && onClick(partialSum.current[Math.max(index - 1, 0)])}
                    >
                        { part + ' ' }
                    </span>
                )}
            </div>}
        </>
    )
}

export default ScrollingOverflow;